import { Card, CardHeader, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import AddIcon from "@mui/icons-material/Add";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import PageLoading from "../../../components/Loading/PageLoading";
import { allEmaildetails } from "../callQuery";
import BASEURL from "../../Utils/Baseurl";
import request from "graphql-request";
import TableComponent from "../../../components/GridTable/TableComponent";

const MailListTable = () => {
  const [mailtableData, setmailtableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const handleNewMail = (e) => {
    navigate("/maildetails/add-mail");
  };
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const onMailForm = (e) => {
    if (e?.id) {
      navigate(`/maildetails/add-mail?${e?.id}`);
    }
  };
  const mailListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.NO",
        // flex: 1,
        width: 80,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Mail Log ID",
        field: "malid",
        name: "E-Mail ID",
        flex: 0.9,
        // width: 150,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Organization Name",
        field: "organisationName",
        name: "organisationName",
        flex: 1.4,
        editable: false,
        disableColumnMenu: true,
      },
      // {
      //   headerName: "Name",
      //   field: "name",
      //   name: "Name",
      //   flex: 1,
      //   editable: false,
      //   disableColumnMenu: true,
      // },
      {
        label: "Email From",
        field: "emailFrom",
        name: "emailFrom",
        flex: 1.2,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Email To",
        field: "emailTo",
        name: "emailTo",
        flex: 1.2,
        disableColumnMenu: true,
        editable: false,
      },
    

      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "createdAt",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
      },
    ],
    rows: mailtableData.sort((a, b) => b.id - a.id).map((item, index) => ({
      sno: index + 1,
      id: item.id,
      malid: item.malid,
      organisationName:item.organisationName,
      name: item.name,
      emailFrom: item.fromEmail,
      emailTo: item.toEmail,
      createdBy: item.user.username,
      createdAt: item.createdAt.slice(0, 10),
    })),
  };
  const fetchCallData = () => {
    setIsLoading(true);
    request(BASEURL, allEmaildetails).then((res) => {
      setmailtableData(res.allEmaildetails);
    })
    .finally(() => {
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchCallData();
  }, []);

  const onCheck=(list)=>
    {
      console.log("id-c",list)
    }
    
  const onDeleteALL=()=>
    {
      console.log("id-DELE")
    }

  return (
    <>
      <DashboardLayout>
        <TableComponent
        tableLoading={isLoading ? true : false}
        columns={mailListTable.columns}
        rowsData={mailListTable.rows}
        head="Mail List"
        actions={true}
        checked={false}
        view={true}
        showAdd = {true}
        onCheck={onCheck}
        onEdit={onMailForm}
        // onDelete={onDelete}
        onView={onMailForm}
        onDeleteALL={onDeleteALL}
        addList={() => handleNewMail()}
        />
        {/* <Card>
          <CardHeader
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Mail Log List
                  </MaterialTypography>
                </Stack>
                <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<AddIcon />}
                  onClick={() => handleNewMail()}
                >
                  Add Mail
                </MaterialButton>
              </Stack>
            }
          ></CardHeader>
          {!isLoading && (
            <MaterialDataGrid
              rows={mailListTable.rows}
              columns={mailListTable.columns}
              onRowClick={onMailForm}
              loading={pageState.loading}
              localeText={{
                noRowsLabel: (
                  <Stack
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    spacing={1}
                  >
                    <MaterialTypography
                      variant="body2"
                      fontWeight="medium"
                      color="text"
                    >
                      No mail found
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                      You have not yet add any mail details. Click on the "Add
                      Mail" button to start adding Call details.
                    </MaterialTypography>
                  </Stack>
                ),
              }}
            />
          )}

          {isLoading && <PageLoading />}
        </Card> */}
      </DashboardLayout>
    </>
  );
};

export default MailListTable;
